import { Fragment, useState } from 'react';
import DefaultLayout from '../../../components/Layouts/DefaultLayout';
import { Button, Tab, Tabs } from 'react-bootstrap';
import {
  AlertDefaultError,
  PermissionsGate,
} from '../../../components/PermissionsGate';
import PrimaryDatePicker from '../../../components/PrimaryDatePicker';
import Select from 'react-select';
import PrimaryDataTable from '../../../components/PrimaryDataTable';
import { columns } from '../const';
import DataTable from '../Reports/DataTable';
import { useBankDepositoryLists } from '../../Banks/components/Query/BankQuery';

const StatementOfCashFlowScreen = ({
  tableData,
  isLoading,
  form,
  onSearch,
  onChange,
  onExport,
}) => {
  const { bankDropdown, isFetching: isBankLoading } = useBankDepositoryLists();
  const [dataGenerated, setDataGenerated] = useState(false);

  const handleSearch = () => {
    // Perform search operation here
    setDataGenerated(true);
    onSearch(); // Call the search function
  };

  return (
    <PermissionsGate
      scopes={['can_view_cash_flow']}
      RenderError={AlertDefaultError}
    >
      <DefaultLayout title="Statement Of Cash Flow">
        <Tabs
          id="controlled-tab-example"
          //   activeKey={selectedTab}
          className="default-tab"
        >
          <Tab
            className="default-tab-content"
            eventKey="statement_of_cash_flow"
            title="Statement Of Cash Flow"
          >
            <div className="row">
              <div className="col-md-2">
                <label>Date From</label>
                <label className="req">*</label>

                <PrimaryDatePicker
                  name={'date_from'}
                  datePickerFormat={'yyyy-MM-dd'}
                  datePickerFormatString={'YYYY-MM-DD'}
                  value={form.date_from}
                  onChange={(date) =>
                    onChange({
                      target: { name: 'date_from', value: date },
                    })
                  }
                />
              </div>
              <div className="col-md-2">
                <label>Date To</label>
                <label className="req">*</label>
                <PrimaryDatePicker
                  name={'date_to'}
                  datePickerFormat={'yyyy-MM-dd'}
                  datePickerFormatString={'YYYY-MM-DD'}
                  value={form.date_to}
                  onChange={(date) =>
                    onChange({
                      target: { name: 'date_to', value: date },
                    })
                  }
                />
              </div>
              <div className="col-md-2">
                <label>Select Bank </label>

                <Select
                  isMulti
                  name="bank_id"
                  options={bankDropdown}
                  isLoading={isBankLoading}
                  menuPlacement="auto"
                  placeholder="ALL"
                  menuPosition="fixed"
                  classNamePrefix={'bk-select'}
                  onChange={(e) =>
                    onChange({
                      target: {
                        name: 'bank_id',
                        value: e,
                      },
                    })
                  }
                />
              </div>
              <div className="col-md-2">
                <PermissionsGate scopes={['can_export_cash_flow']}>
                  <label>&nbsp;</label>
                  <div>
                    <button className="btn btn-primary" onClick={handleSearch}>
                      Generate
                    </button>
                  </div>
                </PermissionsGate>
              </div>
              <div className="col-md-4 text-right">
                <label>&nbsp;</label>
                <div>
                  <Button variant="info" onClick={onExport}>
                    Export
                  </Button>
                </div>
              </div>
            </div>

            <br />

            {dataGenerated ? (
              <DataTable isLoading={isLoading} data={tableData} params={form} />
            ) : (
              <div class="text-center">
                <p>Please click on "Generate" to display information.</p>
              </div>
            )}
          </Tab>
        </Tabs>
      </DefaultLayout>
    </PermissionsGate>
  );
};
export default StatementOfCashFlowScreen;
